<template>
  <div class="content background1">
    <div class="tableBox9">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane label="设备类型" name="first">
              <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
            <el-tab-pane label="所属区域" name="second">
              <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <div class="tableBox10">
      <div class="tableMes">
        <div class="table" style="padding: 0">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{ $t('label_272') }}</p>
            <div class="chooseBox spaceBetween">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText">
                      <p>设备名称</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-input v-model="facilityName"></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose" style="margin-left:20px">
                    <div class="selectText">
                      <p>申请日期</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
                        :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox">
                <div>
                  <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i
                      class="el-icon-search"></i>查询</div>
                </div>
              </div>
            </div>
            <div class="spotStatusNumList2" style="padding: 0 16px;">
              <div class="statusMesBox2" v-for="(item,index) in spotStatusNumList" :key="index"
                :class="item.check==true?'check':''">
                <div class="iconBox" :style="{'color':item.color}"><i :class="item.icon"></i></div>
                <div class="textBox">
                  <p>{{item.text}}</p>
                  <p class="num" :class="item.check==true?'greenFont':''">{{item.num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="item.check"></el-checkbox>
                </div>
              </div>
            </div>

            <div class="spotMes2Box">
              <div class="buttonBox">
                <div>
                  <div class="chooseButton searchButton" @click="addFactory($t('btn_14'))" v-if="MenuRoleList.indexOf('4')>=0">
                    <i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
                  </div>
                  <div class="chooseButton searchButton" @click="addFactory($t('btn_15'))">
                    <i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
                  </div>
                  <div class="chooseButton deleteButton" @click="factoryDel"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
                  <div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-view"></i>查看</div>
                  <div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-s-claim"></i>验收</div>
                  <div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-document"></i>批量申请</div>
                  <div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-circle-close"></i>关闭
                  </div>
<!--                  <div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-upload2"></i>导出</div>-->
                </div>
              </div>
              <!-- 页面table -->
            <div class="tableMin" style="margin-top:10px">
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row
                  @current-change="handleCurrentChangeTree" style="width: 100%;margin: 5px;overflow: auto;
                  border-left: 1px solid #ebeef5;border-right: 1px solid #ebeef5;" height="481"
                  :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">

                  <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex"
                    width="50">
                  </el-table-column>
                  <el-table-column prop="equipmentName" header-align="center" label="设备名称" align="left">
                    <template slot-scope="scope">
                      <p class="tableMiTitle">
                        <span style="font-size: 16px; font-weight: 600;">
                          {{scope.row.equipmentName1}}
                        </span>
                        <br>
                        <span>
                          {{scope.row.equipmentName2}}
                        </span>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="transformationContent" header-align="center" width="220" label="技改内容" align="left">
                    <template slot-scope="scope">
                      <span style="font-size: 16px; font-weight: 600;">
                        {{scope.row.transformationContent1}}
                      </span>
                      <br>
                      <span>
                        {{scope.row.transformationContent2}}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="applicationDate" label="申请日期" align="center">
                  </el-table-column>
                  <el-table-column prop="executionDate" label="执行日期" align="center">
                  </el-table-column>
                  <el-table-column prop="itemNumber" label="项目数量" align="center">
                  </el-table-column>
                  <el-table-column prop="transformationPersonnel" label="技改人员" align="center">
                  </el-table-column>
                  <el-table-column prop="orderStatus" label="工单状态" align="center">
                    <template slot-scope="scope">
                      <p :style="{color:(scope.row.orderStatus=='1'?'green':'green')}">
                        {{scope.row.orderStatus=='1'?'已申请':'技改中'}}
                      </p>
                    </template>
                  </el-table-column>
                </el-table>

                <div style="position: absolute;bottom: 10px;left: 30%">
                  <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
                    :currentspage="1" @parentMethod="searchPage"></Page>
                </div>
            </div>
            </div>

          </div>

        </div>
      </div>
    </div>
<!-- 新增弹框 -->
    <el-dialog :title="factoryDialogTitle" :visible.sync="dialogFactory" append-to-body :close-on-click-modal='false'
      width="1050px"  top="5%" :before-close="handleClose" custom-class="dialogBox">

      <div class="dialogBoxMes" style="padding:0 20px;">
       <div class="dialogMes">
          <div class="dialogMes">
            <p>设备名称</p>
            <div class="mesInput">
              <el-input v-if="factoryDialogTitle == $t('btn_14')" v-model="dialogFactoryEdit.name">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <el-input v-if="factoryDialogTitle == $t('btn_15')" :disabled="true" v-model="dialogFactoryEdit.name">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left:20px">
            <p>所在区域</p>
            <div class="mesInput">
              <el-input maxlength="200" v-model="dialogFactoryEdit.area"></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left:20px">
            <p>申请日期</p>
            <div class="mesInput">
              <el-date-picker v-model="dialogFactoryEdit.applyDate" type="date" placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>
      </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p>申请人</p>
            <div class="mesInput">
              <el-input maxlength="200" v-model="dialogFactoryEdit.applicant"></el-input>
            </div>
          </div>
          <div class="dialogMes" style="margin-left:30px">
            <p><span style="color: #ff0000">*</span>作业风险类别</p>
            <div class="mesInput" style="width: 400px">
              <el-checkbox label="登高"></el-checkbox>
              <el-checkbox label="电工作业"></el-checkbox>
              <el-checkbox label="高空"></el-checkbox>
              <el-checkbox label="动火"></el-checkbox>
            </div>
          </div>
        </div>

      <div class="treeMes" style="height: 500px;">
        <div class="spotMesBox" style="height:100%;">
            <el-tabs v-model="activeNameSpot">
              <el-tab-pane label="技改项目" name="transformationProject" v-if="MenuRoleList.indexOf('9')>=0">
                <transformationProject></transformationProject>
              </el-tab-pane>
              <el-tab-pane label="技改组成员" name="Member" v-if="MenuRoleList.indexOf('13')>=0">
                <transformationMember></transformationMember>
              </el-tab-pane>
            </el-tabs>
        </div>
      </div>
      <div style="position: absolute;bottom: 70px;left: 30%">
        <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
          @parentMethod="searchPage"></Page>
      </div>
        <span slot="footer" class="dialog-footer">
          <span class="buttonBox" style="justify-content: center">
            <div class="chooseButton searchButton" style="width: 150px">暂存</div>
            <div class="chooseButton searchButton" style="width: 150px" @click="apply">申请</div>
          </span>
        </span>
      </div>
    </el-dialog>
    <!-- 申请 弹框 -->
    <el-dialog title="设备技术改造批量申请" :visible.sync="dialogApply" append-to-body :close-on-click-modal='false' width="850px"
      top="10%" :before-close="handlecloseApply" custom-class="dialogBox">
      <div style="height: 600px;display:flex;overflow-y:scroll;">
        <div class="dialogBoxMes" style="padding:0 20px; width: 40%;">
          <div class="titleMes_one">
            <p>技改计划源</p>
          </div>
          <div class="titleMesT" style="margin-top:10px">
            <p>{{techTransformItemSource.area}}</p>
            <p>{{techTransformItemSource.deviceName}}</p>
          </div>
          <div class="textbox_one">
            <p>{{techTransformItemSource.deviceCode}}</p>
          </div>
          <div class="tableMin" style="margin-top: 10px;">
            <div class="left_title2">技改项目：{{techTransformItemSource.techTransformItem}}</div>
            <div class="mainbox">
              <div class="left_title3">技改方案：</div>
              <p v-for='(item,index) in techTransformItemSource.solution' :key="index">{{index+1}}、{{item}}
              </p>
            </div>
            <div class="left_title2" style="height:80px">预期目标：</div>
          </div>
        </div>
        <div style='width:20%;'>
          <div @click="leftadd"
            style='margin-top:200px;margin-right:20px;margin-left:30px;padding:5px 20px;background-color: #3fb393;color:#ffffff;font-weight: 600;text-align:center;'>
            &lt;&lt; </div>
        </div>
        <div class="tableBox9" style='position:unset;'>
          <div class="tableMes">
            <div class="tittle">
              <p>技改设备</p>
            </div>
            <div class="table">
              <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
                <el-tab-pane label="设备类型" name="first">
                  <tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
                </el-tab-pane>
                <el-tab-pane label="所属区域" name="second">
                  <tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import "@/assets/css/map/map.css"
  import "@/assets/css/common/spot.css"
  import Page from "@/components/common/page";
  import TimePage from "@/assets/js/timePage/timePage.js";
  import utils from '@/utils/utils'
  import file from "@/assets/js/file/file.js";
  import tree from "@/components/list/tree/checkTree";
  import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
  import transformationProject from "@/components/list/displayPage/transformationProject";
  import transformationMember from "@/components/list/displayPage/transformationMember";

  export default {
    name: 'planResume',
    components: {
      Page,
      tree,
      transformationProject,
      transformationMember
    },
    data() {
      return {
        techTransformItemSource: {
          area: '机电部 车间1 产线1',
          deviceName: '放电加工机 EA6',
          deviceCode: 'YFHEGHO0003',
          techTransformItem: '换油保养',
          solution: ['打开飞轮后方安全网，松开飞轮外侧六角螺丝放置正下方放油', '松开滑块右侧六角螺丝在下方放置小部品箱盛接',
            '将飞轮升降滑块油重新按要求加好（螺丝要缠防水胶带上紧，有螺丝撸扣要及时更换）', '冲床上方两个平衡气缸加油，下方两人辅助推车一个空桶一个油桶（注意新废油区分）',
            '将费油过坪秤并做好标识放置好', '最后卫生整理'
          ],
        },
        pageNum: 1,
        pageSize: 10,
        pageCount: 0,
        Readytime: '',
        getTreeMes: '1',
        height: '',
        MenuRoleList: [],
        facilityName: '',
        tableData: [{
          equipmentName1: '放电加工机 EA6',
          equipmentName2: 'YFHEGHO003',
          transformationContent1: '电机清洗',
          transformationContent2: '拆卸电机外壳,利用机油泵喷洗...',
          applicationDate: '2019/8/18',
          executionDate: '2021/6/20',
          itemNumber: '8',
          transformationPersonnel: '李三',
          orderStatus: '已申请'
        }, {
          equipmentName1: '放电加工机 EA6',
          equipmentName2: 'YFHEGHO003',
          transformationContent1: '电机清洗',
          transformationContent2: '拆卸电机外壳,利用机油泵喷洗...',
          applicationDate: '2021/10/02',
          executionDate: '2021/12/31',
          itemNumber: '18',
          transformationPersonnel: '李四',
          orderStatus: '已申请'
        },{
          equipmentName1: '放电加工机 EA6',
          equipmentName2: 'YFHEGHO003',
          transformationContent1: '电机清洗',
          transformationContent2: '拆卸电机外壳,利用机油泵喷洗...',
          applicationDate: '2021/10/02',
          executionDate: '2021/12/31',
          itemNumber: '18',
          transformationPersonnel: '李四',
          orderStatus: '已申请'
        },{
          equipmentName1: '放电加工机 EA6',
          equipmentName2: 'YFHEGHO003',
          transformationContent1: '电机清洗',
          transformationContent2: '拆卸电机外壳,利用机油泵喷洗...',
          applicationDate: '2021/10/02',
          executionDate: '2021/12/31',
          itemNumber: '18',
          transformationPersonnel: '李四',
          orderStatus: '已申请'
        },{
          equipmentName1: '放电加工机 EA6',
          equipmentName2: 'YFHEGHO003',
          transformationContent1: '电机清洗',
          transformationContent2: '拆卸电机外壳,利用机油泵喷洗...',
          applicationDate: '2021/10/02',
          executionDate: '2021/12/31',
          itemNumber: '18',
          transformationPersonnel: '李四',
          orderStatus: '已申请'
        },{
          equipmentName1: '放电加工机 EA6',
          equipmentName2: 'YFHEGHO003',
          transformationContent1: '电机清洗',
          transformationContent2: '拆卸电机外壳,利用机油泵喷洗...',
          applicationDate: '2021/10/02',
          executionDate: '2021/12/31',
          itemNumber: '18',
          transformationPersonnel: '李四',
          orderStatus: '已申请'
        }],
        treeData: {
          dataDevice: [],
          searchShow: true,
          statusShow: false,
          statusListShow: true,
          cardShow: true,
          dataAll: true,
          funtoGetMes: '2'
        },
        treeData2: {
          dataDevice: [],
          searchShow: true,
          statusShow: false,
          statusListShow: true,
          cardShow: true,
          dataAll: true,
          funtoGetMes: '3'
        },
        spotStatusNumList: [{
          icon: 'el-icon-document',
          text: '已申请',
          check: true,
          num: '0',
          color: '#3fb393'
        }, {
          icon: 'el-icon-document-checked',
          text: '技改中',
          check: true,
          num: '0',
          color: '#3fb393'
        }, {
          icon: 'el-icon-s-claim',
          text: '验收中',
          check: true,
          num: '0',
          color: '#3fb393'
        }, {
          text: '已完成',
          check: false,
          num: '0',
          color: '#9A9A9A'
        }],
        tableDataTreeInfo: {}, //页面数据
        factoryDialogTitle: this.$t('btn_14'), //弹出框的标题
        dialogFactory: false, //弹出框的当前状态
        dialogApply: false, //申请弹出框的当前状态
        dialogFactoryEdit: {
          name: "",
          area: "",
          applyDate: '2022-04-19',
          applicant: "",
        },
        dialogApplyEdit: {},
        deviceDetailMes: {},
        tableDataTreeTime: [],
        activeNameTree: 'first',
        statusNumList: [],
        id: '',
        factoryTypeList: [],
        activeNameSpot: 'transformationProject',
      }
    },
    methods: {
      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      handler(row) {
        this.id = row.equipmentId;
      },
      // handleClose() {
      //   this.dialogDeviceSpot = false;
      //   this.dialogSpotResult = false;
      //   this.dialogSpotBatchTimeEdit = false;

      // },
      //弹框关闭
      handleClose() {
        this.dialogFactory = false;
        //this.dialogApply = false;

      },
      handlecloseApply() {
        this.dialogApply = false;
      },

      handleCurrentChangeTree(info) {
        this.tableDataTreeInfo = info;
      },


      handleCurrentChangeTreeTime(info) {},
      handleClickTree(tab, event) {
        this.getTreeMes = '1';
        this.deviceDetailMes = {};
        this.search({
          pageNum: 1,
          pageSize: this.pageSize,
        });
      },

      leftadd() {},
      search(param) {
        // this.Readytime = ["2021-12-01T05:49:18.184Z", "2022-01-23T05:49:18.184Z", ]
        var dataParam = {
          beginTime: this.Readytime[0],
          endTime: this.Readytime[1],
          code: this.code,
          type: this.deviceDetailMes.type,
          id: this.deviceDetailMes.id,
        }
        var newParam = Object.assign(param, dataParam);
        this.pageNum = newParam.pageNum;
        this.pageSize = newParam.pageSize;
        this.searchPage(newParam);
        this.searchStauts(newParam);
      },
      searchPage(param) {
        SpotCheck.getCheckCount(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.tableDataTreeTime = data.data.records
            // for (var q = 0; q < this.tableDataTreeTime.length; q++) {
            // 	this.tableDataTreeTime[q].tName = '';
            // 	this.tableDataTreeTime[q].dName = '';
            // 	for (var i = this.tableDataTreeTime[q].typeName.length - 2; i >= 0; i--) {
            // 		this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[i] + ' ';
            // 	}
            // 	this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[this.tableDataTreeTime[q].typeName.length - 1]
            // 	for (var i = this.tableDataTreeTime[q].deptName.length - 1; i >= 0; i--) {
            // 		this.tableDataTreeTime[q].dName += this.tableDataTreeTime[q].deptName[i] + ' ';
            // 	}
            // }
            this.pageSize = data.data.size;
            this.pageCount = data.data.total;
            this.pageNum = data.data.current;
            this.$refs['pageModel'].setCurrent(this.pageNum);
          }
        }).catch((response) => {
          console.log(response)
        })
      },
      searchStauts(param) {
        SpotCheck.getCheckStatus2(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.statusNumList = data.data
          }
        }).catch((response) => {
          console.log(response)
        })
      },


      excel() {
        if (this.id != '' && this.id != null) {
          window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentCheckRecord/excel?time=' + this
            .Readytime[0]
            .substring(0, 7) + "&id=" + this.id;
        } else {
          utils.messageAlert("请选择要导出的设备", this.$t('label_358'), this.$t('label_100'));
        }
      },

      apply() {
        this.dialogApply = true;
      },

      //点击删除按钮
      factoryDel() {
        let param = this.tableDataTreeInfo.id;
        if (Object.keys(this.tableDataTreeInfo).length > 0) {
          this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning',
          }).then(() => {
            file.delEquipmentParts(param).then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.search();
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          }).catch(() => {});
        } else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
        }
      },

      exportClick() {
        this.$refs.exportBox.setExportExcel();
      },

      //点击编辑选中的数据
      addFactory(title) {
        this.factoryDialogTitle = title;
        if (title != this.$t('btn_14')) {
          if (Object.keys(this.tableDataTreeInfo).length > 0) {
            this.dialogFactory = true;
            this.dialogFactoryEdit = this.tableDataTreeInfo;
            file.saveEquipmentPartsInfoByid(this.tableDataTreeInfo.id).then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.dialogFactory = true;
                this.dialogFactoryEdit = data.data
              } else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
              }
            }).catch((response) => {
              console.log(response)
            })
          } else {
            utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
          }
        } else {
          this.dialogFactory = true;
        }
      },


      getDeviceMes(data) {
        if (data.name == this.$t('label_272')) {
          this.deviceDetailMes = {};
          this.search({
            pageNum: 1,
            pageSize: this.pageSize,
          });
        } else {
          this.deviceDetailMes = data;
          this.search({
            pageNum: 1,
            pageSize: this.pageSize,
          });
        }
      },
      getNowTime() {
        let zeroTime = new Date();
        let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
          1; //月份从0开始，因此要+1
        let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
        let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
        return now;
      },
      getBeforeTime() {
        var time = (new Date).getTime() + 24 * 60 * 60 * 1000;
        let zeroTime = new Date(time);
        let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
          1; //月份从0开始，因此要+1
        let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
        let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
        return now;
      },
    },
    created() {
      this.Readytime = [this.getNowTime(), this.getBeforeTime()]
      this.search({
        pageNum: 1,
        pageSize: this.pageSize
      });
      this.MenuRoleList = this.$store.getters.getMenu;
    }
  }
</script>

<style scoped>
  .spotStatusNumList2 {
    width: 100%;
    display: flex;
  }
  .spotStatusNumList2 .statusMesBox2 {
    display: flex;
    justify-content: space-around;
    width: 15%;
    border: 1px solid #dcdcdc;
    background: #efefef;
    padding: 15px 0;
    margin: 10px;
  }
  .spotStatusNumList2 .statusMesBox2 .iconBox {
    width: 50px;
    height: 50px;
    text-align: center;
  }
  .spotStatusNumList2 .statusMesBox2.check {
    border: 1px solid #3fb393;
  }
  .spotStatusNumList2 .statusMesBox2 i {
    font-size: 40px;
    color: #3fb393;
    line-height: 50px;
  }
  .spotStatusNumList2 .statusMesBox2 .num {
    font-size: 30px;
    font-weight: bold;
    color: #9A9A9A;
  }
  .dialogBoxMes .titleMes_one {
    background-position: left;
    width: 95%;
    margin-left: 2%;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;
  }
  >>> .el-autocomplete {
    display: none ;
  }
  .dialogBoxMes .titleMesT {
    background: url("/static/img/spot/txtBlack.png") no-repeat;
    background-position: left;
    padding-left: 30px;
    width: 95%;
    margin-left: 5%;
    font-size: 18px;
    font-weight: bold;
  }
  .textbox_one {
    margin-left: 5%;
    padding-left: 30px;
  }
  .left_title2 {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #EFEFEF;
    font-weight: 600;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #e2e2e2;
  }
  .left_title3 {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #EFEFEF;
    font-weight: 600;
    padding-left: 10px;
    box-sizing: border-box;
  }
  .tittle {
    font-size: 18px;
    font-weight: bold;
    padding-left: 10px;
    margin-top: -10px;
  }
  .mainbox {
    background: #EFEFEF;
    height: 270px;
    border-bottom: 1px solid #e2e2e2;
  }
  .mainbox p {
    padding-left: 10px;
    padding-right: 15px;
  }
  .spotStatusNumList2 .statusMesBox2 .greenFont {
    color: #3fb393;
  }
</style>



// WEBPACK FOOTER //
// src/pages/transformationAdmin/planResume.vue